<app-page-header useInlineHeader="true">
    {{ 'Add Team Member(s)' }}
    <a mat-icon-button disableRipple
       [attr.aria-label]="routerBackButton.ariaLabel"
       [routerLink]="routerBackButton.route">
        <mat-icon>arrow_back</mat-icon>
    </a>
</app-page-header>

<form [formGroup]="formGroup">
    <app-details-card-container animated delayed [fadeFrom]="'bottom'">
        <mat-card>
            <mat-card-content>
                <div *ngFor="let admin of admins.controls; let i = index" class="form-group">
                    <app-avatar-block [initials]="initials(admin.get('fullName').value)" [class.hidden]="admin.get('isEditing').value">
                            <span avatarTitle withEdit="true">
                                {{ admin.get('fullName').value }}
                                <button mat-icon-button linkButton disableRipple (click)="admin.get('isEditing').setValue(true)">
                                    <mat-icon [svgIcon]="'v2:fi-br-edit'"></mat-icon>
                                </button>
                            </span>
                        <span avatarDescription>
                                <span [innerHTML]="admin.get('role').value === 'pmcUser' ? 'Property Manager' : 'Community Manager'"></span>
                                <span [innerHTML]="' • ' + (admin.get('organizations').value?.length | i18nPlural: organizationsMapping)"></span>
                            </span>
                        <span avatarDescription>
                                <span [innerHTML]="admin.get('email').value"></span>
                                <span [innerHTML]="admin.get('phone').value ? ' • ' + (admin.get('phone').value | legfiPhone) : ''"></span>
                            </span>
                    </app-avatar-block>
                </div>
                <app-team-member-add-card [formGroup]="formGroup" [showOrganizationSelect]="true">
                    <lf-control-messages [control]="admins" [prefix]="'At least once team member'"></lf-control-messages>
                </app-team-member-add-card>
            </mat-card-content>
        </mat-card>

        <mat-toolbar>
            <a mat-flat-button disableRipple color="accent"
               [attr.aria-label]="'Cancel add community'"
               [routerLink]="routerBackButton.route"
               [queryParams]="routerBackButton.queryParams">
                {{ 'Cancel' }}
            </a>

            <flex-spacer></flex-spacer>

            <button mat-flat-button disableRipple color="primary" [disabled]="savingTeamMember" (click)="submit()">
                {{ 'Save and Apply' }}
            </button>
        </mat-toolbar>
    </app-details-card-container>
</form>
